module.exports = __webpack_public_path__ + "img/ring_skip_0_null_1@3x.a01c81c9.png";